(function () {
  'use strict';

  var modal = document.getElementById('video-modal');
  if (!modal) {
    return;
  }

  var player = modal.querySelector('[data-video-player]');
  var titleEl = modal.querySelector('[data-video-title]');
  var linkEl = modal.querySelector('[data-video-link]');
  var lastFocus = null;

  function youtubeEmbed(url) {
    var match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{6,})/);
    return match ? 'https://www.youtube.com/embed/' + match[1] + '?rel=0&autoplay=1' : null;
  }

  function vimeoEmbed(url) {
    var match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? 'https://player.vimeo.com/video/' + match[1] + '?autoplay=1' : null;
  }

  function wistiaPlayer(id) {
    var wrap = document.createElement('div');
    wrap.className = 'video-player__wistia';
    wrap.innerHTML =
      '<wistia-player media-id="' +
      id +
      '" aspect="1.7777777777777777"></wistia-player>';
    var script = document.createElement('script');
    script.src = 'https://fast.wistia.com/embed/' + id + '.js';
    script.async = true;
    script.type = 'module';
    wrap.appendChild(script);
    return wrap;
  }

  function buildPlayer(url) {
    if (!url) {
      return '<div class="video-player__placeholder"><span class="video-player__play" aria-hidden="true"></span><span class="video-player__label">Video unavailable</span></div>';
    }

    var yt = youtubeEmbed(url);
    if (yt) {
      return '<iframe class="video-player__iframe" src="' + yt + '" title="Video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }

    var vimeo = vimeoEmbed(url);
    if (vimeo) {
      return '<iframe class="video-player__iframe" src="' + vimeo + '" title="Video player" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }

    if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) {
      return '<video class="video-player__native" src="' + url + '" controls autoplay playsinline></video>';
    }

    return '<iframe class="video-player__iframe" src="' + url + '" title="Video player" allowfullscreen></iframe>';
  }

  function openModal(trigger) {
    lastFocus = trigger;
    titleEl.textContent = trigger.getAttribute('data-title') || '';
    linkEl.href = trigger.getAttribute('data-permalink') || '#';
    player.innerHTML = '';
    var wistia = trigger.getAttribute('data-wistia') || '';
    if (wistia) {
      player.appendChild(wistiaPlayer(wistia));
    } else {
      player.innerHTML = buildPlayer(trigger.getAttribute('data-url') || '');
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-modal-open');
    modal.querySelector('[data-close-video]').focus();
  }

  function closeModal() {
    player.innerHTML = '';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('video-modal-open');
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-video]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    if (event.target.closest('[data-close-video]') || event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  var searchInput = document.querySelector('[data-video-search]');
  var grid = document.querySelector('[data-video-grid]');
  var feature = document.querySelector('[data-video-feature]');
  var listHead = document.querySelector('[data-video-list-head]');
  var empty = document.querySelector('[data-video-empty]');
  var moreWrap = document.querySelector('[data-video-more-wrap]');
  var moreBtn = document.querySelector('[data-video-more]');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.video-card')) : [];
  var moreHasRemaining = !!(moreBtn && moreWrap);

  function setMoreVisibility(query) {
    if (!moreWrap || !moreHasRemaining) {
      return;
    }
    moreWrap.hidden = !!query;
  }

  function filterCards() {
    if (!searchInput) {
      return;
    }

    var query = (searchInput.value || '').toLowerCase().trim();
    var visible = 0;
    var gridVisible = 0;

    if (feature) {
      var featureHay = (feature.getAttribute('data-search') || '').toLowerCase();
      var showFeature = !query || featureHay.indexOf(query) !== -1;
      feature.hidden = !showFeature;
      if (showFeature) {
        visible += 1;
      }
    }

    cards.forEach(function (card) {
      var hay = (card.getAttribute('data-search') || '').toLowerCase();
      var show = !query || hay.indexOf(query) !== -1;
      card.hidden = !show;
      if (show) {
        visible += 1;
        gridVisible += 1;
      }
    });

    if (listHead) {
      listHead.hidden = gridVisible === 0;
    }
    if (grid) {
      grid.hidden = gridVisible === 0;
    }

    setMoreVisibility(query);

    if (empty) {
      empty.hidden = visible > 0;
      empty.classList.toggle('is-visible', visible === 0);
    }
  }

  if (searchInput && (grid || feature)) {
    searchInput.addEventListener('input', filterCards);

    var form = document.querySelector('[data-video-search-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        filterCards();
      });
    }

    if (searchInput.value) {
      filterCards();
    }
  }

  if (moreBtn && grid) {
    var moreLabel = moreBtn.textContent;
    moreBtn.addEventListener('click', function () {
      var cfg = window.valideaVideoLibrary || {};
      if (!cfg.ajaxUrl || !cfg.nonce || moreBtn.disabled) {
        return;
      }

      moreBtn.disabled = true;
      moreBtn.setAttribute('aria-busy', 'true');
      moreBtn.textContent = moreBtn.getAttribute('data-loading') || 'Loading…';

      var body = new FormData();
      body.append('action', 'validea_video_library_more');
      body.append('nonce', cfg.nonce);
      body.append('offset', moreBtn.getAttribute('data-offset') || '0');

      fetch(cfg.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: body,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (payload) {
          var data = payload && payload.data ? payload.data : {};
          if (!payload || !payload.success) {
            throw new Error('Could not load more videos');
          }

          var wrap = document.createElement('div');
          wrap.innerHTML = data.html;
          Array.prototype.slice.call(wrap.querySelectorAll('.video-card')).forEach(function (card) {
            grid.appendChild(card);
            cards.push(card);
          });

          moreBtn.setAttribute('data-offset', String(data.offset || 0));
          moreHasRemaining = !!data.hasMore;
          if (moreWrap) {
            moreWrap.hidden = !moreHasRemaining;
          }
          filterCards();
        })
        .catch(function () {
          moreHasRemaining = true;
          if (moreWrap) {
            moreWrap.hidden = false;
          }
        })
        .then(function () {
          moreBtn.disabled = false;
          moreBtn.removeAttribute('aria-busy');
          moreBtn.textContent = moreLabel;
        });
    });
  }
})();
